import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
// Generated by Copilot - Archit Agarwal
export class DateUtilService {

  constructor(private datePipe: DatePipe) { }

  /**
   * Converts an API date string (datetimeoffset) to display format (MM/dd/yyyy)
   * without timezone shift. Treats the date as UTC to prevent day-off issues
   * for users in different timezones.
   * Use this for calendar dates like DOB, Date of Death, etc.
   */
  formatCalendarDateForDisplay(date?: string): string {
    if (!date) return '';

    let parsedDate: Date;
    const hasTimeOrZone = /T|\d{2}:\d{2}/.test(date);

    if (!hasTimeOrZone) {
      parsedDate = new Date(date + 'T00:00:00Z');
    } else {
      parsedDate = new Date(date);
    }

    if (isNaN(parsedDate.getTime())) {
      return '';
    }

    return this.datePipe.transform(parsedDate, 'MM/dd/yyyy', 'UTC') || '';
  }

  /**
   * Converts a datepicker-selected date to API format (OffsetDateTime-compatible)
   * without timezone shift. Extracts local date parts to preserve
   * the user's intended date regardless of their timezone, then appends
   * midnight UTC so the backend can parse it as OffsetDateTime.
   * Use this for calendar dates like DOB, Date of Death, etc.
   */
  formatCalendarDateForApi(date: any): string {
    if (!date) return '';

    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) {
      return '';
    }

    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const day = String(parsedDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T00:00:00.000Z`;
  }
}
